import {
  AfterViewChecked,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { HttpHeaders } from '@angular/common/http';
import { TourService } from 'src/app/api/tourism/tour.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import { GalleryTourismComponent } from 'src/app/components/gallery-tourism/gallery-tourism.component';
import Sortable from 'sortablejs';
declare var $: any;

@Component({
  selector: 'app-packagetour-gallery-img',
  templateUrl: './packagetour-gallery-img.component.html',
  styleUrls: ['./packagetour-gallery-img.component.css']
})
export class PackagetourGalleryImgComponent
  implements OnInit, AfterViewChecked {
  @ViewChild('sortableContainer') sortableContainer!: ElementRef;
  @ViewChild(GalleryTourismComponent) GalleryTourismComponent: any;

  branchofficeSlug: string = '';
  nameMenu: string = 'gallery_image';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  numberMaxImg: number = environment.max_number_img;

  imageUrl: any = null;
  fileUrlImage: any = null;

  filesToUpload: any = [];
  photosOld: any = [];

  // sortable
  sortableInstanciado = false;
  sortableInstance: any;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private packagetourService: PackagetourService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      description: [''],
      url_image: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    this.showloaderLogin();
    if (this.isEdit) {
      this.editData();
    }
  }

  ngAfterViewChecked(): void {
    if (
      this.photosOld.length > 0 &&
      this.sortableContainer &&
      !this.sortableInstanciado
    ) {
      this.sortableInstanciado = true;
      // Destruir instancia previa si existe
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
      }

      this.sortableInstance = Sortable.create(
        this.sortableContainer.nativeElement,
        {
          animation: 150,
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          fallbackClass: 'sortable-fallback',
          forceFallback: true, // fuerza el uso del clon, mejora consistencia visual
          onEnd: (event: any) => {
            const movedItem = this.photosOld.splice(event.oldIndex, 1)[0];
            this.photosOld.splice(event.newIndex, 0, movedItem);
            this.photosOld.forEach((img: any, idx: any) => {
              img.position = idx + 1;
            });
          }
        }
      );
    }
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  editData() {
    this.packagetourService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          description: _item.description,
          url_image: _item.url_image
        });
        this.photosOld = _item.gallery_image_str;
        this.photosOld = this.photosOld
          .sort((a: any, b: any) => {
            if (a.position == null && b.position == null) return 0;
            if (a.position == null) return 1;
            if (b.position == null) return -1;
            return a.position - b.position;
          })
          .map((img: any, index: any) => {
            // Asegurarse de que todos tengan un position asignado en memoria
            img.position = index + 1;
            return img;
          });

        this.sortableInstanciado = false; // 🧠 Habilita reinicio de Sortable

        this.hideloaderLogin();
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onFileSelectedMult(event: any): void {
    // Reset the files array on each selection
    this.filesToUpload = [];

    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (this.toolsService.validateSizeImg(file, true)) {
        // Add file to the array
        this.filesToUpload.push(file);
        // Generate image preview
        this.generateImagePreview(file);
      }
    }
  }

  generateImagePreview(file: any): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      file['previewUrl'] = e.target.result;
      file['tag'] = '';
      file['position'] = '';
    };
    reader.readAsDataURL(file);
  }

  changePositionImage(param: any, index: number): void {
    this.filesToUpload[index].position = param.value;
  }

  changeTagImage(param: any, index: number): void {
    this.filesToUpload[index].tag = param.value;
  }

  removeImage(index: any) {
    this.filesToUpload.splice(index, 1);
  }

  changeTagImageOld(param: any, index: number): void {
    this.photosOld[index].tag = param.value;
  }

  changePositionImageOld(param: any, index: number): void {
    console.log();
    this.photosOld[index].position = param.value;
  }

  removeImageOld(index: any) {
    this.photosOld.splice(index, 1);
  }

  extendsGalleryTourism(event: any): void {
    console.log(event);
    for (let i in event) {
      this.photosOld.push(event[i]);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    if (this.validate()) {
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('id', this.checkId.toString());
      formData.append('url_image', this.fileUrlImage);

      formData.append('photosold', JSON.stringify(this.photosOld));

      this.packagetourService.saveImage(formData).subscribe({
        next: (data: any) => {
          this.showloaderLogin();
          this.alertifyMsg.success('Registro actualizado con éxito');
          this.filesToUpload = [];
          this.photosOld = [];
          this.editData();
        }
      });
    }
  }

  validate() {
    let total_img_ = environment.max_number_img;
    let sum_ = this.photosOld.length + this.filesToUpload.length;
    if (sum_ > total_img_) {
      this.alertifyMsg.warning(
        'Solo puede registrar un máximo de ' + total_img_ + ' imágenes'
      );
      return false;
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/paquetes/lista']);
  }

  refresh() {
    this.showloaderLogin();
    this.filesToUpload = [];
    this.editData();
  }

  showloaderLogin() {
    (<HTMLInputElement>(
      document.getElementById('box-loading-gallery')
    )).style.display = 'block';
  }

  hideloaderLogin() {
    (<HTMLInputElement>(
      document.getElementById('box-loading-gallery')
    )).style.display = 'none';
  }
}
